export default "__VITE_ASSET__CUnTVNUo__"